module.exports = __webpack_public_path__ + "static/media/time-session-90.ebaa6f49.svg";